import { render } from "./StepDots.vue?vue&type=template&id=bc78ea24&scoped=true"
import script from "./StepDots.vue?vue&type=script&lang=js"
export * from "./StepDots.vue?vue&type=script&lang=js"

import "./StepDots.vue?vue&type=style&index=0&id=bc78ea24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc78ea24"]])

export default __exports__